import { createFileRoute } from "@tanstack/react-router";
import { ensureCatalogEntries } from "../../features/catalog/queries";
import { LandingPage } from "../../pages/LandingPage";
import { localizedLinks, localizedUrl } from "../../i18n/localeHead";

export const Route = createFileRoute("/_site/")({
  staticData: { landing: true },
  loader: ({ context }) => ensureCatalogEntries(context.queryClient),
  head: () => ({
    meta: [{ property: "og:url", content: localizedUrl("/") }],
    links: localizedLinks("/"),
  }),
  component: LandingRoute,
});

function LandingRoute() {
  return <LandingPage />;
}
